import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
// validation Formik
import * as Yup from "yup";
import { Formik } from "formik";
// import config from "../../config";
import yupconfig from "../../../../yupconfig";

import PropTypes from "prop-types";
import { ClientnoteGridViewApi, clientnoteUpdateApi, closeAddNoteForm } from "store/slices/clientnoteSlice";
import { sweatalert } from "component/Sweatalert2";
import { TextareaField } from "component/form/Field";
import { getClientNoteSubmitError, isClientNoteLocked } from "./clientNoteForm";

import RichNoteEditor from "./RichNoteEditor";
import { isRichClientNote, sanitizeClientNoteHtml, serializeRichClientNote, clientNoteHasText } from "./clientNoteRichText";

const NoteUpdate = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const detail = props && props.detail;

  const locked = isClientNoteLocked(detail);
  const richNote = isRichClientNote(detail?.note);

  const initialValues = {
    note: "",
  };

  const validationSchema = Yup.object().shape({
    note: Yup.string().trim().label(t("Note")).required().test("note-content", t("Note is required"), value => !richNote || clientNoteHasText(value)),
  });
  yupconfig();
  
  const handleNoteSubmit = (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
    if (locked) { setSubmitting(false); return; }
    setLoading(true);
    dispatch(clientnoteUpdateApi({...values, note: richNote ? serializeRichClientNote(values.note) : values.note, id: detail.id, client_id: detail.client_id })).then((action) => {
      if (action.meta.requestStatus === "fulfilled") {
        resetForm();
        dispatch(ClientnoteGridViewApi({ client_id: detail.client_id }));
        dispatch(closeAddNoteForm());
        sweatalert({ title: t("Updated"), text: t("Updated Successfully"), icon: "success" });
      } else if (action.meta.requestStatus === "rejected") {
        const status = action.payload && action.payload.status;
        const errors = action.payload && action.payload.message && action.payload.message.errors;
        if (status === 422) {
          setErrors(errors);
        }
        setStatus({ success: false, error: getClientNoteSubmitError(action) });
        setSubmitting(false);
      }
    });
    setLoading(false);
  };

  return (
    <>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleNoteSubmit}>
        {(formik) => {
          useEffect(() => {
            if(detail.note){
              formik.setFieldValue('note', richNote ? sanitizeClientNoteHtml(detail.note) : detail.note, false);
            }
          }, [detail]);
          return (
            <>
              <form noValidate onSubmit={formik.handleSubmit} className="photoform">
                {richNote ? <RichNoteEditor readOnly={locked} value={formik.values.note} onChange={value => formik.setFieldValue("note", value)} onBlur={() => formik.setFieldTouched("note", true)} label={t("Client Notes")} error={formik.touched.note && formik.errors.note} /> : <TextareaField type="text" name="note" className="note-textarea" placeholder={t("For example, allergic to latex")} value={formik.values.note} label={t("Client Notes")} controlId="clientForm-note" />}
                {formik.status?.error && <div className="alert alert-danger mt-2" role="alert">{formik.status.error}</div>}
                <button type="submit" className="btn btn-primary w-100 btn-md mt-3" disabled={loading || locked}>
                  {loading && <span className="spinner-border spinner-border-sm"></span>}
                  {t("Update")}
                </button>
              </form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

NoteUpdate.propTypes = {
  detail:PropTypes.oneOfType([PropTypes.node,PropTypes.array, PropTypes.object]),
};

export default NoteUpdate;
